<template>
  <CustomForm ref="form" :inputs=inputs :submit=buttons.submit style="max-width: 400px; margin: auto;">
    <CustomTextField :content=inputs.siret />
    <CustomTextField :content=inputs.siren />
    <CustomAddressField ref="addressField" style="margin-top: 15px" :content=inputs.structuredAddressPro @update:value="value => inputs.address.value = value" />
    <CustomTextField :content=inputs.defaultTvaNumber />
    <CustomTextField :content=inputs.phone />
    <CustomTextField :content=inputs.mail />
    <CustomTextAreaField style="height: 150px; margin-bottom: 15px" :content=inputs.other />
    <CustomButton style="margin-top: 30px" @click="submitForm" :params=buttons.submit />
  </CustomForm>
</template>

<script>
    import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
    import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
    import router from "@/router";
    import {NotificationService} from "@vues/v-common";
    import CustomForm from "@/components/forms/CustomForm.vue";
    import {BusinessGroupParamsController} from "@/controllers/business/BusinessGroupParamsController";
    import CustomTextAreaField from "@/components/forms/customs/customTextAreaField/CustomTextAreaField.vue";
    import {TokenService} from "@/services/TokenService";
    import CustomAddressField from "@/components/forms/customs/customAddressField/CustomAddressField.vue";
    import {normalizeIdentifier, SIREN_MASK, SIRET_MASK, sirenFromSiret} from "@/utils";

    /**
     * Identité de l'entreprise : les informations du bloc vendeur affiché sur les documents (dans le même ordre).
     */
    export default {
        name: 'BusinessGroupIdentityForm',
        components: {
          CustomAddressField,
          CustomTextAreaField,
          CustomForm,
          CustomButton,
          CustomTextField,
        },
        data: function () {
            return {
                inputs: {
                  structuredAddressPro: {street: '', streetNumber: '', addressLine2: '', postalCode: '', city: '', country: '', countryCode: ''},
                  address: {required: true, value: ''},
                  siret: {label: 'Siret', value: '', type: 'text', mask: SIRET_MASK, required: true, minDigits: SIRET_MASK.maxDigits},
                  siren: {label: 'Siren', value: '', type: 'text', mask: SIREN_MASK, required: true},
                  defaultTvaNumber: {label: 'Numéro de TVA', value: '', type: 'text'},
                  phone: {label: 'Téléphone', value: '', type: 'text'},
                  mail: {label: 'Mail', value: '', type: 'text'},
                  other: {label: 'Informations supplémentaires', value: ''},
                },
                buttons:{
                  submit: {text: "Mettre à jour"},
                },
            }
        },
        async mounted(){
          this.$refs.form?.startLoading();
          const resp = await BusinessGroupParamsController.get(localStorage.groupId)
          if(!resp.errors){
            this.inputs.structuredAddressPro = resp.structuredAddressPro || {street: '', streetNumber: '', addressLine2: '', postalCode: '', city: '', country: '', countryCode: ''};
            this.inputs.siret.value = normalizeIdentifier(resp.structuredInformations?.siret, SIRET_MASK.maxDigits);
            this.inputs.siren.value = normalizeIdentifier(resp.structuredInformations?.siren, SIREN_MASK.maxDigits);
            this.inputs.defaultTvaNumber.value = resp.defaultTvaNumber;
            this.inputs.phone.value = resp.structuredInformations?.phoneNumber;
            this.inputs.mail.value = resp.structuredInformations?.mail;
            this.inputs.other.value = resp.structuredInformations?.other;
          }
          this.$refs.form?.stopLoading();
        },
      watch: {
        'inputs.siret.value'(siret) {
          const siren = sirenFromSiret(siret);
          if (siren) { this.inputs.siren.value = siren }
        }
      },
      methods: {
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => BusinessGroupParamsController.patch(localStorage.groupId, {
            structuredAddressPro:  this.$refs.addressField.getValue(),
            structuredInformations: {
              siret: normalizeIdentifier(this.inputs.siret.value, SIRET_MASK.maxDigits),
              siren: normalizeIdentifier(this.inputs.siren.value, SIREN_MASK.maxDigits),
              phoneNumber: this.inputs.phone.value,
              mail: this.inputs.mail.value,
              other: this.inputs.other.value,
            },
            defaultTvaNumber: this.inputs.defaultTvaNumber.value
          }));
          if (!res.errors) {
            (new NotificationService).addNotification("success","Identité de l'entreprise modifiée");
            TokenService.renewToken();
            router.push("/group-parameters");
          }
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
</style>
